import { Box } from '@mui/material';

import { styled } from '@mui/material/styles';

export const Wrapper = styled(Box)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: ${(p) => p.theme.spacing(1)};
`;
